import React from 'react';
import { FormField } from 'react-hooks-form';
import RichText from 'packages/ui/RichTextField';

function RichTextFieldWrapper({ onChange, name, value, ...rest }) {
  return <RichText {...rest} onChange={val => onChange(val)} value={value || ''} />;
}

function RichTextField({ name, ...rest }) {
  return <FormField {...rest} component={RichTextFieldWrapper} name={name} />;
}

export default RichTextField;
